/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import {
  isObjectOrArrayAndEmpty,
  shouldComponentNotUpdateUnlessGraphChange
} from '../../../shared/Utils/Utils';
import ConnectionError from '../../../shared/ErrorComponents/ConnectionError';
import withLoadingStatus from '../../../shared/StatusWrappers/LoadingStatus';
import withErrorStatus from '../../../shared/StatusWrappers/ErrorStatus';
import {
  IAny,
  IDetailComponentProps,
  IUtilityBillBreakdownAPIResponse
} from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import {
  BreakdownChartsComponent,
  IBreakdownChartsComponentProps
} from './BreakdownCharts/BreakdownChartsComponent';

interface IUtilityBillBreakdown extends IBreakdownChartsComponentProps {
  onRefresh?: IAny;
  isMonthly?: boolean;
}

const UtilityBreakdownChartContent = (props: IUtilityBillBreakdown) => {
  const d = descriptors.energyManagement;
  const [t] = useTranslation();
  const { chartData, currencyCode, utilityType, onRefresh, isMonthly } = props;
  if (isObjectOrArrayAndEmpty(chartData)) {
    return (
      <div className="errorDisplay">
        <ConnectionError
          title={t(d.CONNECTIONERRORTITLE)}
          message={t(d.CONNECTIONERROR)}
          onRefresh={onRefresh}
        />
      </div>
    );
  }
  return (
    <div>
      <BreakdownChartsComponent
        utilityType={utilityType}
        currencyCode={currencyCode}
        chartData={chartData}
        isMonthly={isMonthly ? isMonthly : false}
      />
    </div>
  );
};

const UtilityBreakdownChartWithLoader = withLoadingStatus(
  withErrorStatus(UtilityBreakdownChartContent)
);

interface IUtilityBillBreakdownChartWidgetProps extends IDetailComponentProps {
  utilityType: string;
  isMonthly?: boolean;
  graphData?: any;
}
const UtilityBillBreakdownChartWidgetTogglePerformance = React.memo(
  (props: IUtilityBillBreakdownChartWidgetProps) => {
    const [t] = useTranslation();
    const d = descriptors.energyManagement;
    const { dataConnector, utilityType, isMonthly } = props;

    interface IUtilityBillBreakdownExtended {
      data: IUtilityBillBreakdownAPIResponse;
    }

    const onRefresh = () => {
      return new Promise((resolve, reject) => {
        resolve('');
      });
    };
    // dataConnector && dataConnector.actions && dataConnector.actions.getAll();
    const { all, loading, error, status } = {
      all: [],
      loading: false,
      error: { name: '', message: '', rawResponse: '', status: 200, data: '' },
      status: 200
    };
    const utilityBillBreakdownData = props.graphData;

    //const utilityBillBreakdownData = (all as unknown) as IUtilityBillBreakdownExtended;
    const isDataAvailable = utilityBillBreakdownData ? true : false;
    const [isLoading, setIsLoading] = useState<boolean>(loading);
    const [statusCode, setStatusCode] = useState<number | null>(0);
    const [errorInfo, setErrorInfo] = useState(error);
    const [data, setData] = useState({} as IUtilityBillBreakdownExtended);

    useEffect(() => {
      setData(props.graphData);
    }, [props.graphData]);

    return (
      <>
        {data?.data && (
          <UtilityBreakdownChartContent
            // loading={false}
            // error={{name: '', message: '', rawResponse: '', data:''}}
            // statusCode={200}
            // // onRefresh={onRefresh}
            // loadingText={t(d.LOADING)}
            // title={t(d.CONNECTIONERRORTITLE)}
            // noDataMessage={t(d.NODATAAVAILABLE)}
            // connectionErrorMessage={t(d.CONNECTIONERROR)}
            chartData={data?.data?.utilityAggregations}
            utilityType={utilityType}
            currencyCode={data?.data?.utilityCostCurrency}
            isMonthly={isMonthly ? isMonthly : false}
          />
        )}
      </>
    );
  },
  shouldComponentNotUpdateUnlessGraphChange
);
export default UtilityBillBreakdownChartWidgetTogglePerformance;
